import { useTranslations as useNextIntlTranslations } from "next-intl";
import type { ReactNode } from "react";

export type Messages = typeof import("./messages/en.json");

type TranslationValues = Record<string, string | number | Date>;

type RichTranslationValues = Record<
  string,
  | string
  | number
  | Date
  | ReactNode
  | ((chunks: ReactNode) => ReactNode)
  | undefined
>;

type MarkupTranslationValues = Record<
  string,
  string | number | Date | ((chunks: string) => string) | undefined
>;

export type UseTranslationsReturn<T extends keyof Messages> = ((
  key: keyof Messages[T],
  values?: TranslationValues,
) => string) & {
  rich: (key: keyof Messages[T], values?: RichTranslationValues) => ReactNode;
  markup: (key: keyof Messages[T], values?: MarkupTranslationValues) => string;
};

const useTranslations = <T extends keyof Messages>(
  namespace: T,
): UseTranslationsReturn<T> => {
  return useNextIntlTranslations(
    namespace as string,
  ) as UseTranslationsReturn<T>;
};

export default useTranslations;
